import messages from './messages'

// 默认语言
let locale = 'cn';

// 域名后的第一级路径
let pathnameFisrt = window.location.pathname.replace(/^\/([^\/]+).*/i, '$1');
// 匹配是否有合适的语言
if (pathnameFisrt && pathnameFisrt != '/' && messages[pathnameFisrt] && pathnameFisrt == messages[pathnameFisrt].base) {
    locale = pathnameFisrt;
}

// 后台用到的lang参数
let lang = messages[locale].apiLocale;
// 设置存储，方便使用
localStorage.setItem('lang', lang);
// 基于语言的base路径
let base = messages[locale].base;

// console.log(`locale:${locale}\r\nbase:/${base}\r\nlang:${lang}`);

export default {
    locale,
    base,
    lang
}